import CModal from '../CModal';
import { UseMutationOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import { customersGroupsQueryOptions } from '../../utils/queryOptions';
import { IconUsersGroup } from '@tabler/icons-react';
import { useState } from 'react';
import { Avatar, Checkbox, message } from 'antd';
import { apiV1 } from '../../utils/apiClient';

interface MultiGroupSelectModalProps {
  open: boolean,
  onClose: ()=> void,
  customersIds: string[] | undefined
}

const MultiGroupSelectModal = ({open, onClose, customersIds}: MultiGroupSelectModalProps) => {

  const queryClient = useQueryClient()
  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);

  const manualGroups = useQuery(customersGroupsQueryOptions({type: 'manual'}))

  function handleClick(id: string) {
    setSelectedGroups((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  }

  const addToGroups : UseMutationOptions<any>= {
    mutationFn: async ()=>{
      for (const selectedGroup of selectedGroups) {
        await apiV1.put(`/shop/customers/groups/${selectedGroup}/customers`, {customers: customersIds, action: 'add'})
      }
    },
    onSuccess: async ()=>{
      await queryClient.invalidateQueries({queryKey: ['customers-groups']})
      onClose()
      message.success(`Aggiunti a ${selectedGroups.length} gruppi`)
    }
  }

  return (
    <CModal mutationOptions={addToGroups} open={open && !!customersIds?.length} icon={<IconUsersGroup/>} onClose={()=>{setSelectedGroups([]); onClose()}} color={'blue'} disabled={!selectedGroups.length} confirmButtonText={`Aggiungi a ${selectedGroups.length} gruppi`} >
      <div className={'flex flex-col gap-1'}>
        {manualGroups.data?.map((item)=>(
          <div key={item.id} onClick={()=> handleClick(item.id)} className={'flex gap-2 items-center hover:bg-slate-50 p-3 rounded-md cursor-pointer'}>
            <Checkbox checked={selectedGroups.includes(item.id)}/>
            <Avatar className={'bg-primary'} icon={<IconUsersGroup size={16}/>}/>
            <p>{item.name}</p>
          </div>
        ))}
      </div>
    </CModal>
  );
};
export default MultiGroupSelectModal;
